import React from 'react';

import Show from 'components/Show';
import Nothing from 'components/Misc/Nothing';
import { Button, Datepicker } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

import Add from 'containers/Administrator/Users/Profile/Student/Payments/Add';
import Generate from 'containers/Administrator/Users/Profile/Student/Payments/Generate';
import Payment from 'containers/Administrator/Users/Profile/Student/Payments/Payment';
import Summary from 'containers/Administrator/Users/Profile/Student/Payments/Summary';

import { useStudentPaymentStore } from 'store/user/useStudentPaymentStore';

const Grade = ({ grade }) => {
	// Use student's payment store
	const payments = useStudentPaymentStore(state => state.payments.filter(payment => payment.gradeId === grade.id));

	return (
		<div className="pt-3 px-4 pb-4 space-y-4 border rounded-lg dark:border-neutral-700">
			{/* <div className="p-4 flex flex-col space-y-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"> */}
			<div className="flex items-center space-x-2">
				<Title
					title={grade.title}
					subtitle={grade.program.title}
					className="flex-1"
				/>

				<Datepicker
					readOnly
					value={grade.startDate}
				/>

				<Datepicker
					readOnly
					value={grade.endDate}
				/>
			</div>

			{/* Show nothing if no payments */}
			<Nothing visible={!payments.length} />
			
			{/* Payment collection */}
			<Show if={payments?.length}>
				<div className="flex flex-col space-y-3">
					{payments?.map(payment =>
						<Payment key={payment.key} payment={payment} />
					)}
				</div>
			</Show>

			{/* Add payment modal */}
			<Add gradeId={grade.id} />
			
			{/* Generate payments modal */}
			<Generate gradeId={grade.id} />

			{/* Payment summary */}
			<Summary payments={payments} />
		</div>
	);
};

export default Grade;